import React, { useEffect, useRef, useState } from 'react';
import { API_URL } from '../config/api';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

function LoginPage({ onLogin }) {
  const [isSignup, setIsSignup] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const googleButtonRef = useRef(null);

  useEffect(() => {
    if (!GOOGLE_CLIENT_ID || !googleButtonRef.current) return;

    const scriptId = 'google-identity-script';
    const renderGoogleButton = () => {
      if (!window.google?.accounts?.id || !googleButtonRef.current) return;

      window.google.accounts.id.initialize({
        client_id: GOOGLE_CLIENT_ID,
        callback: async (response) => {
          try {
            setLoading(true);
            setError('');
            const res = await fetch(`${API_URL}/auth/google`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ credential: response.credential })
            });
            const data = await res.json();
            if (!res.ok || !data.ok) {
              setError(data.error || 'No se pudo iniciar sesión con Google');
              setLoading(false);
              return;
            }
            onLogin(data.token, data.user._id);
          } catch (err) {
            setError('Error: ' + err.message);
            setLoading(false);
          }
        }
      });

      googleButtonRef.current.innerHTML = '';
      window.google.accounts.id.renderButton(googleButtonRef.current, {
        theme: 'outline',
        size: 'large',
        shape: 'pill',
        text: 'continue_with',
        width: 320
      });
    };

    const existing = document.getElementById(scriptId);
    if (existing) {
      renderGoogleButton();
      return;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = renderGoogleButton;
    document.head.appendChild(script);
  }, [onLogin]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      if (isSignup && password !== confirmPassword) {
        setError('Las contraseñas no coinciden');
        setLoading(false);
        return;
      }

      const endpoint = isSignup ? '/auth/signup' : '/auth/login';
      const res = await fetch(`${API_URL}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      const data = await res.json();

      if (!data.ok) {
        setError(data.error || 'Error en autenticación');
        setLoading(false);
        return;
      }

      onLogin(data.token, data.user._id);
    } catch (err) {
      setError('Error: ' + err.message);
      setLoading(false);
    }
  };

  return (
    <div className="app login-screen">
      <div className="login-container">
        <img src="/logo.png" alt="Logo QueComo" className="login-logo" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
        <h1>QueComo</h1>
        <p>Tu organizador semanal de comidas con IA</p>
        <p className="login-warmup">El inicio de sesión puede demorar hasta 20 segundos.</p>

        {error && <p className="error">{error}</p>}

        {GOOGLE_CLIENT_ID ? (
          <div className="google-login-block">
            <div ref={googleButtonRef} className="google-button-wrap" />
            <div className="separator"><span>o continuar con email</span></div>
          </div>
        ) : null}

        <form onSubmit={handleSubmit} className="login-form">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {isSignup && (
            <input
              type="password"
              placeholder="Confirmar contraseña"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          )}
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Cocinando tu sesión...' : isSignup ? 'Registrarse' : 'Ingresar'}
          </button>
        </form>

        <p className="toggle-auth">
          {isSignup ? '¿Ya tienes cuenta? ' : '¿No tienes cuenta? '}
          <button
            type="button"
            onClick={() => {
              setIsSignup(!isSignup);
              setError('');
              setEmail('');
              setPassword('');
              setConfirmPassword('');
            }}
            className="link-button"
          >
            {isSignup ? 'Inicia sesión' : 'Regístrate'}
          </button>
        </p>
      </div>
    </div>
  );
}

export default LoginPage;
